import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, BACKEND_URL } from "@/lib/api";

export const TopRachas = () => {
  const [rachas, setRachas] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/analytics/club/rachas");
        setRachas(data.rachas || []);
      } catch (e) { /* silent */ }
    })();
  }, []);

  if (rachas.length === 0) return null;

  return (
    <div className="border border-amber-500/40 mb-8" data-testid="top-rachas-card">
      <div className="p-4 border-b border-amber-500/30 bg-amber-500/5 flex items-center justify-between">
        <div className="overline text-amber-500">🔥 Top rachas del club</div>
        <div className="text-[10px] font-mono text-muted-foreground uppercase">Semanas seguidas jugando</div>
      </div>
      <div className="divide-y divide-border">
        {rachas.map((r, i) => (
          <Link
            key={r.player_id}
            to={`/player/${r.player_id}`}
            data-testid={`racha-row-${r.player_id}`}
            className="flex items-center gap-3 p-3 hover:bg-amber-500/5 transition-colors"
          >
            <div className={`w-6 text-center font-heading font-black text-sm ${i === 0 ? "text-amber-400" : "text-muted-foreground"}`}>{i + 1}</div>
            <div className="w-9 h-9 border border-border bg-white/5 flex items-center justify-center overflow-hidden shrink-0 font-heading font-black text-xs">
              {r.photo_url
                ? <img src={`${BACKEND_URL}${r.photo_url}`} alt={r.name} className="w-full h-full object-cover" />
                : (r.jersey_number ?? r.name?.[0])}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-heading font-bold uppercase tracking-tight text-sm truncate">{r.name}</div>
              <div className="text-[11px] text-muted-foreground font-mono truncate">{r.team_name}</div>
            </div>
            <div className="inline-flex items-center gap-1 border border-amber-500/60 bg-amber-500/10 text-amber-500 px-2 py-1 text-[11px] font-heading font-black uppercase tracking-wider shrink-0">
              🔥 {r.racha_semanas} sem
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
